import AddOnTriggerNode from './AddOnTriggerNode';
import BranchConsolidateNode from './BranchConsolidateNode';
import BranchRootNode from './BranchRootNode';
import CustomNode from './CustomNode';
import ElementNode from './ElementNode';
import EndRunNode from './EndRunNode';
import LoopConnectorNode from './LoopConnectorNode';
import LoopEndNode from './LoopEndNode';
import LoopStartNode from './LoopStartNode';
import NoBranchNode from './NoBranchNode';
import NoLoopNode from './NoLoopNode';
import PlaceholderPlusButtonNode from './PlaceholderPlusButtonNode';
import SetupNode from './SetupNode';
import SkippedContextualNode from './SkippedContextualNode';
import ToolTriggerNode from './ToolTriggerNode';
import VirtualContextualNode from './VirtualContextualNode';
import { NodeTypes } from '@/components/FlowTree/flow-tree-service.const';

export const NODE_TYPE_COMPONENT_MAP = {
	[NodeTypes.Setup]: SetupNode,
	[NodeTypes.EndRun]: EndRunNode,
	[NodeTypes.Custom]: CustomNode,
	[NodeTypes.Element]: ElementNode,
	[NodeTypes.LoopEnd]: LoopEndNode,
	[NodeTypes.LoopStart]: LoopStartNode,
	[NodeTypes.BranchRoot]: BranchRootNode,
	[NodeTypes.ToolTrigger]: ToolTriggerNode,
	[NodeTypes.AddOnTrigger]: AddOnTriggerNode,
	[NodeTypes.LoopConnector]: LoopConnectorNode,
	[NodeTypes.SkippedContextual]: SkippedContextualNode,
	[NodeTypes.VirtualContextual]: VirtualContextualNode,
	[NodeTypes.BranchConsolidate]: BranchConsolidateNode,
	[NodeTypes.EmptyNodePlusPlaceholder]: PlaceholderPlusButtonNode,
	[NodeTypes.NoVisibleBranch]: NoBranchNode,
	[NodeTypes.NoVisibleLoop]: NoLoopNode,
};
